import { useState, useCallback } from 'react';

interface EntityModalStackItem {
	entityType: string;
	entityId: string;
}

interface EntityModalState {
	isOpen: boolean;
	modalStack: EntityModalStackItem[];
}

export function useEntityModal() {
	const [modalState, setModalState] = useState<EntityModalState>({
		isOpen: false,
		modalStack: []
	});

	const openEntityModal = useCallback((entityType: string, entityId: string) => {
		setModalState(prevState => ({
			isOpen: true,
			modalStack: [...prevState.modalStack, { entityType, entityId }]
		}));
	}, []);

	const closeEntityModal = useCallback(() => {
		setModalState({
			isOpen: false,
			modalStack: []
		});
	}, []);

	const goBackModal = useCallback(() => {
		setModalState(prevState => {
			const newStack = [...prevState.modalStack];
			newStack.pop(); // Remove the current modal

			return {
				isOpen: newStack.length > 0,
				modalStack: newStack
			};
		});
	}, []);

	const getCurrentModal = useCallback(() => {
		if (modalState.modalStack.length === 0) {
			return null;
		}
		return modalState.modalStack[modalState.modalStack.length - 1];
	}, [modalState.modalStack]);

	return {
		modalState,
		openEntityModal,
		closeEntityModal,
		goBackModal,
		getCurrentModal,
		hasParentModal: modalState.modalStack.length > 1
	};
}
